import Icon from '@mdi/react';

interface FeatureCardProps {
  iconPath: string;
  title: string;
  description: string;
  isMobile: boolean;
}

function FeatureCard({ iconPath, title, description, isMobile }: FeatureCardProps) {
  return (
    <div
      style={styles.featureCard}
      onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-5px)')}
      onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0px)')}
    >
      <div style={styles.featureIcon}>
        <Icon path={iconPath} size={3} color="#dc2626" />
      </div>
      <h3 style={styles.featureTitle}>{title}</h3>
      <p style={styles.featureDescription}>{description}</p>
    </div>
  );
}

export default FeatureCard;

const styles = {
  featureCard: {
    textAlign: 'center' as const,
    padding: '40px 20px',
    background: 'white',
    borderRadius: '20px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e2e8f0',
    transition: 'transform 0.3s ease',
  },

  featureIcon: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'center',
  },

  featureTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    margin: '0 0 16px 0',
  },

  featureDescription: {
    color: '#64748b',
    lineHeight: '1.6',
    margin: '0',
  },
};
